import { createFileRoute, notFound } from '@tanstack/react-router';
import { LANGUAGES, type Language } from '@noor/lib';
import { OperatingRulesDocument } from '@/pages/legacy-operating';

/**
 * `/ru|uz|en/operating-rules` — the public operating-rules document in a fixed
 * language, so a link can name the language instead of relying on the
 * visitor's stored pref. Anything else under `/$lang/` is a real 404.
 */
export const Route = createFileRoute('/$lang/operating-rules')({
  beforeLoad: ({ params }) => {
    if (!LANGUAGES.includes(params.lang as Language)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw notFound();
    }
  },
  component: LangOperatingRules,
});

function LangOperatingRules() {
  const { lang } = Route.useParams();
  return <OperatingRulesDocument lang={lang as Language} />;
}
